export enum State {
    Active = "Active",
    Pending = "Pending",
    Inactive = "Inactive",
  }